/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { templateCreate } from '../fn/templates/template-create';
import { TemplateCreate$Params } from '../fn/templates/template-create';
import { templateDelete } from '../fn/templates/template-delete';
import { TemplateDelete$Params } from '../fn/templates/template-delete';
import { templateGetAll } from '../fn/templates/template-get-all';
import { TemplateGetAll$Params } from '../fn/templates/template-get-all';
import { TemplateResponse } from '../models/template-response';
import { TemplatesResponse } from '../models/templates-response';
import { templateUpdate } from '../fn/templates/template-update';
import { TemplateUpdate$Params } from '../fn/templates/template-update';

@Injectable({ providedIn: 'root' })
export class TemplatesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `templateGetAll()` */
  static readonly TemplateGetAllPath = '/ordering/templates/{templateType}';

  /**
   * Gets all templates by template type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `templateGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  templateGetAll$Response(params: TemplateGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<TemplatesResponse>> {
    return templateGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all templates by template type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `templateGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  templateGetAll(params: TemplateGetAll$Params, context?: HttpContext): Observable<TemplatesResponse> {
    return this.templateGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<TemplatesResponse>): TemplatesResponse => r.body)
    );
  }

  /** Path part for operation `templateCreate()` */
  static readonly TemplateCreatePath = '/ordering/templates/{templateType}';

  /**
   * Creates a template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `templateCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  templateCreate$Response(params: TemplateCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TemplateResponse>> {
    return templateCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `templateCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  templateCreate(params: TemplateCreate$Params, context?: HttpContext): Observable<TemplateResponse> {
    return this.templateCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TemplateResponse>): TemplateResponse => r.body)
    );
  }

  /** Path part for operation `templateUpdate()` */
  static readonly TemplateUpdatePath = '/ordering/templates/{templateType}/{templateId}';

  /**
   * Updates a template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `templateUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  templateUpdate$Response(params: TemplateUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TemplateResponse>> {
    return templateUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `templateUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  templateUpdate(params: TemplateUpdate$Params, context?: HttpContext): Observable<TemplateResponse> {
    return this.templateUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TemplateResponse>): TemplateResponse => r.body)
    );
  }

  /** Path part for operation `templateDelete()` */
  static readonly TemplateDeletePath = '/ordering/templates/{templateType}/{templateId}';

  /**
   * Deletes a template.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `templateDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  templateDelete$Response(params: TemplateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return templateDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a template.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `templateDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  templateDelete(params: TemplateDelete$Params, context?: HttpContext): Observable<void> {
    return this.templateDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
